import { Component, OnInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { CallTagService } from '../services/callTag/call.tag.service';
import { UsersComponent } from '../users/users.component';
import { ProviderService } from '../services/providers/provider.service';
import { Auth } from '../services/auth.service';

@Component({
  selector: 'callTag',
  templateUrl: './call-tag.component.html',
//   styleUrls: ['.//users/users.component.css']
})

export class CallTagsComponent extends UsersComponent {

  name:string;
  hasSysOpsPermission:boolean = false;

  constructor(
    protected router: Router,
    protected callTagService: CallTagService,
    protected providerSevice: ProviderService,
    protected auth: Auth) { super(router, callTagService, providerSevice); }

  protected getDetailUrl(): string {

    return '/callTag/' + this.selectedUser.id;
  };

  protected getUserString(): string {

    return 'callTag';
  };

  protected getUsersString(): string {

    return 'callTags';
  };

  async ngOnInit() {
    this.hasSysOpsPermission = this.auth.hasSysOpsPermission();
    this.getUsers({ limit: this.usersPerGet })
  };

  alertExist:boolean=false;
  alertConfirm:boolean=false;
  closeAlertConfirm(){
    this.createCalled=false
    this.alertConfirm=false;
  }
  closeAlertExist(){
    this.createCalled=false
    this.alertExist=false;
  }

  pushOrdered(callTag){
    for (let i=0;i<this.users.length;i++){
      if (callTag.name.toLowerCase() < this.users[i].name.toLowerCase()){
        this.users.splice(i,0,callTag)
        return;
      }
    }
    this.users.push(callTag)

  }

  finishAdd(){
    this.alertConfirm=false;

    if (this.callTagExist(this.name)) {
      this.alertExist=true;
      this.createCalled=false
      return;
    }
    this.alertExist=false;
    this.callTagService.createCallTag(this.name)
      .then(callTag => {

        this.createCalled = false;
        this.pushOrdered(callTag);
        this.selectedUser = null;
        this.alertCreated=true;
        this.configPages()
        return this;
      })
      .catch(error => {

        this.createCalled = false;
        confirm(error.message)
        return Promise.reject(error.message || error);
      });
  }
  add(): void {
    this.alertConfirm=false;
    this.alertCreated=false;
    this.alertExist=false;

    if (this.createCalled) {
      return;
    }

    if (this.name==undefined) {
      this.alertAdd=true;
      return;
    }

    this.alertAdd=false;
    this.createCalled = true;
    this.alertConfirm=true;


  }

  callTagExist(callTag:string): boolean{
    for (let i=0;i<this.users.length;i++){
      if (callTag.toLowerCase() === this.users[i].name) return true;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/callTags/call-tag.component.ts